(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yhe-creator-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yhe-creator-videos')) {
    class YheCreatorVideos extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (this.controller || !this.isConnected) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('[data-track]');
        this.dialog = this.querySelector('dialog');
        this.stage = this.querySelector('[data-stage]');
        this.triggers = Array.from(this.querySelectorAll('[data-play]'));
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.activeIndex = -1;
        this.returnFocus = null;

        this.triggers.forEach((trigger) => {
          const coverSlot = trigger.querySelector('[data-youtube-cover]');
          if (!coverSlot) return;
          const video = this.parseYouTube(trigger.dataset.url);
          if (!video) return;
          const img = document.createElement('img');
          img.className = 'yhe-cv__cover';
          img.alt = trigger.dataset.title || '';
          img.width = 480;
          img.height = 360;
          img.loading = 'lazy';
          img.decoding = 'async';
          img.addEventListener('error', () => img.remove(), { once: true, ...options });
          img.src = 'https://i.ytimg.com/vi/' + video.id + '/hqdefault.jpg';
          coverSlot.replaceWith(img);
        });

        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-play]');
          if (trigger && this.contains(trigger)) {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            if (typeof this.dialog.showModal !== 'function') return;
            event.preventDefault();
            this.openVideo(this.triggers.indexOf(trigger), trigger);
          }
          if (event.target.closest('[data-close]')) this.closeVideo();
          if (event.target.closest('[data-video-prev]')) this.openVideo(this.activeIndex - 1);
          if (event.target.closest('[data-video-next]')) this.openVideo(this.activeIndex + 1);
          if (event.target.closest('[data-gallery-prev]')) this.moveGallery(-1);
          if (event.target.closest('[data-gallery-next]')) this.moveGallery(1);
        }, options);

        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeVideo();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (!this.dialog.open) this.cleanup();
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.closeVideo();
        }, options);
        document.addEventListener('yhe:creator-video-open', (event) => {
          if (event.target !== this && this.dialog.open) this.closeVideo();
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const card = this.cards.find((item) => item.dataset.blockId === event.detail?.blockId);
          if (card) this.scrollToCard(card, 'auto');
        }, options);
        window.addEventListener('pagehide', () => this.closeVideo(), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateNavigation());
        }, { passive: true, ...options });
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.track);
        this.updateNavigation();
      }

      parseYouTube(raw) {
        try {
          const url = new URL(raw);
          if (!['https:', 'http:'].includes(url.protocol)) return null;
          const host = url.hostname.toLowerCase();
          let id = '';
          let portrait = false;
          if (['youtu.be', 'www.youtu.be'].includes(host)) id = url.pathname.split('/')[1];
          else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host)) {
            const segments = url.pathname.split('/').filter(Boolean);
            if (segments[0] === 'watch') id = url.searchParams.get('v');
            else if (['shorts', 'embed', 'live'].includes(segments[0])) {
              id = segments[1];
              portrait = segments[0] === 'shorts';
            }
          }
          if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) return null;
          const time = url.searchParams.get('start') || url.searchParams.get('t') || '';
          let start = 0;
          if (/^\d+$/.test(time)) start = Number(time);
          else {
            const match = /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/.exec(time);
            if (match) start = Number(match[1] || 0) * 3600 + Number(match[2] || 0) * 60 + Number(match[3] || 0);
          }
          return { id, portrait, start: Math.min(start, 86400) };
        } catch { return null; }
      }

      parseInstagram(raw) {
        try {
          const url = new URL(raw);
          if (!['https:', 'http:'].includes(url.protocol)) return null;
          if (!['instagram.com', 'www.instagram.com', 'm.instagram.com'].includes(url.hostname.toLowerCase())) return null;
          const match = /^\/(reel|reels|p|tv)\/([A-Za-z0-9_-]+)\/?$/.exec(url.pathname);
          if (!match) return null;
          const kind = match[1] === 'reels' ? 'reel' : match[1];
          return 'https://www.instagram.com/' + kind + '/' + match[2] + '/';
        } catch { return null; }
      }

      openVideo(index, opener) {
        if (index < 0 || index >= this.triggers.length) return;
        const trigger = this.triggers[index];
        const card = trigger.closest('[data-card]');
        const kind = trigger.dataset.source;
        if (!this.dialog.open) {
          this.dispatchEvent(new CustomEvent('yhe:creator-video-open', { bubbles: true }));
          this.returnFocus = opener || trigger;
          this.dialog.showModal();
          document.documentElement.classList.add('yhe-cv-modal-open');
        }
        this.clearPlayer();
        this.activeIndex = index;
        this.dialog.dataset.kind = kind;
        this.querySelector('[data-dialog-title]').textContent = trigger.dataset.title || this.dataset.playLabel;
        this.querySelector('[data-dialog-meta]').replaceChildren(card.querySelector('[data-video-meta]').content.cloneNode(true));
        this.querySelector('[data-counter]').textContent = (index + 1) + ' / ' + this.triggers.length;
        this.querySelector('[data-video-prev]').disabled = index === 0;
        this.querySelector('[data-video-next]').disabled = index === this.triggers.length - 1;
        const error = this.querySelector('[data-error]');
        error.hidden = true;
        const original = this.querySelector('[data-original]');
        original.hidden = true;
        original.removeAttribute('href');
        let embedUrl = null;
        let originalUrl = null;
        let portrait = false;

        if (kind === 'youtube') {
          const video = this.parseYouTube(trigger.dataset.url);
          if (video) {
            portrait = video.portrait;
            originalUrl = 'https://www.youtube.com/watch?v=' + video.id;
            const customStart = Number(trigger.dataset.start);
            const start = Number.isFinite(customStart) && customStart > 0 ? Math.min(Math.floor(customStart), 86400) : video.start;
            const params = new URLSearchParams({ autoplay: '1', playsinline: '1', controls: '1', rel: '0', start: String(start) });
            embedUrl = 'https://www.youtube-nocookie.com/embed/' + video.id + '?' + params.toString();
          }
        } else if (kind === 'instagram') {
          originalUrl = this.parseInstagram(trigger.dataset.url);
          if (originalUrl) embedUrl = originalUrl + 'embed/';
          portrait = true;
        } else if (kind === 'shopify') {
          portrait = Number(trigger.dataset.hostedRatio) < 1;
          const template = card.querySelector('[data-hosted-video]');
          if (template) {
            this.stage.append(template.content.cloneNode(true));
            const video = this.stage.querySelector('video');
            if (video) {
              video.addEventListener('error', () => this.showError(), { once: true });
              video.preload = 'metadata';
              video.muted = false;
              const playRequest = video.play();
              if (playRequest) playRequest.catch(() => { /* Native controls remain available. */ });
            }
          }
        }
        if (trigger.dataset.ratio === 'portrait') portrait = true;
        if (trigger.dataset.ratio === 'landscape') portrait = false;
        this.dialog.dataset.portrait = String(portrait);
        if (originalUrl) {
          original.href = originalUrl;
          original.hidden = false;
        }
        if (embedUrl) {
          const iframe = document.createElement('iframe');
          iframe.title = trigger.dataset.title || this.dataset.playLabel;
          iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.src = embedUrl;
          this.stage.append(iframe);
        } else if (kind !== 'shopify' || !this.stage.querySelector('video')) this.showError();
        this.dialog.scrollTop = 0;
      }

      showError() {
        const error = this.querySelector('[data-error]');
        error.textContent = this.dataset.errorLabel;
        error.hidden = false;
      }

      clearPlayer() {
        if (!this.stage) return;
        this.stage.querySelectorAll('video').forEach((video) => video.pause());
        this.stage.replaceChildren();
      }

      closeVideo() {
        if (this.dialog?.open) this.dialog.close();
        this.cleanup();
      }

      cleanup() {
        this.clearPlayer();
        if (!document.querySelector('.yhe-cv__dialog[open]')) document.documentElement.classList.remove('yhe-cv-modal-open');
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        this.returnFocus = null;
      }

      scrollToCard(card, behavior) {
        const trackBox = this.track.getBoundingClientRect();
        const cardBox = card.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const distance = rtl ? cardBox.right - trackBox.right + 4 : cardBox.left - trackBox.left - 4;
        this.track.scrollBy({ left: distance, behavior });
      }

      moveGallery(direction) {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const first = this.cards[0];
        if (!first) return;
        const step = first.getBoundingClientRect().width + 16;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * step * (rtl ? -1 : 1), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      updateNavigation() {
        const nav = this.querySelector('[data-gallery-nav]');
        const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        nav.hidden = !overflow;
        const distance = Math.abs(this.track.scrollLeft);
        this.querySelector('[data-gallery-prev]').disabled = distance < 3;
        this.querySelector('[data-gallery-next]').disabled = distance >= this.track.scrollWidth - this.track.clientWidth - 3;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.closeVideo();
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
      }
    }
    customElements.define('yhe-creator-videos', YheCreatorVideos);
  }

  } catch(e) { console.error(e); }
})();
})();
